import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { LogoImage } from "@/components/Logo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl border border-slate-700 bg-slate-900 px-4 py-3 text-sm text-white outline-none transition-colors focus:border-brand focus:ring-1 focus:ring-brand";

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-slate-950 px-6">
      <div className="pointer-events-none absolute right-0 top-0 h-96 w-96 rounded-full bg-brand/20 blur-3xl" />
      <div className="relative w-full max-w-md">
        <Link to="/" className="mb-8 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white"><ArrowLeft className="h-4 w-4" /> Back to site</Link>
        <div className="rounded-3xl border border-slate-800 bg-slate-900/60 p-8 backdrop-blur-xl">
          <LogoImage className="mx-auto block h-28" />
          <div className="mt-8 flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand/15 text-brand"><Lock className="h-5 w-5" /></div>
            <div><h1 className="font-display text-xl font-bold text-white">Admin Login</h1><p className="text-xs text-slate-400">Manage your leads & inquiries</p></div>
          </div>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div><label className="mb-1.5 block text-sm font-medium text-slate-300">Email</label><input data-testid="login-email" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@massivegrowth.com" /></div>
            <div><label className="mb-1.5 block text-sm font-medium text-slate-300">Password</label><input data-testid="login-password" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" /></div>
            <button type="submit" data-testid="login-submit" disabled={loading} className="w-full rounded-full bg-brand py-3.5 text-sm font-semibold text-white transition-colors hover:bg-brand-hover disabled:opacity-60">{loading ? "Signing in…" : "Sign in"}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
